import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  createBerthOutage,
  deleteBerthOutage,
  fetchBerthOutages,
  updateBerthOutage,
} from "../../apis/berthOutages";

import type { BerthOutage } from "../../utils/types/berthOutages";

export const fetchBerthOutagesList = createAsyncThunk(
  "berthOutages/fetchList",
  async (locationId: string | undefined, { rejectWithValue }) => {
    try {
      return await fetchBerthOutages(locationId);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addBerthOutage = createAsyncThunk(
  "berthOutages/add",
  async (
    { data }: { data: Partial<BerthOutage> },
    { rejectWithValue }
  ) => {
    try {
      return await createBerthOutage(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editBerthOutage = createAsyncThunk(
  "berthOutages/edit",
  async (
    { id, data }: { id: string; data: Partial<BerthOutage> },
    { rejectWithValue }
  ) => {
    try {
      return await updateBerthOutage(id, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeBerthOutage = createAsyncThunk(
  "berthOutages/remove",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await deleteBerthOutage(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
